import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable from "mui-datatables";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import useSave from "../../Hooks/useSave";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import useProtectView from "../../Hooks/useProtectView";
import PreviewIcon from "@mui/icons-material/Preview";
import Popover from "../../components/Popover/Popover";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import NoteIcon from "@mui/icons-material/Note";
import IconMenu from "../../components/subMenu/SubMenu";
import Orders from "./Orders";
import SendIcon from "@mui/icons-material/Send";
import Invoice from "./Components/Invoice";
import useAlert from "../../Hooks/useAlerts";
import EditInvoice from "./Components/EditInvoice";

const menuHeader = {
  icon: "",
  name: "Invoices",
};

const menu = [
  { link: "/invoices/orders", name: "Orders to invoice" },
  { link: "/invoices", name: "invoices" },
];

function EditInvoiceButton() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <Button
      variant="outlined"
      sx={{
        margin: "0px  20px  0px  auto",
      }}
      onClick={() => navigate(`/invoices/edit-invoice/${id}`)}
    >
      {/* <ArrowBackIcon /> */}
      Edit Invoice
    </Button>
  );
}

export default function Invoices() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchGraphql, DialogSave } = useSave();
  const canView = useProtectView();
  const [order, setOrder] = useState({});
  const [products, setProducts] = useState([]);
  const [messages, setMessages] = useState([]);

  const [data, setData] = useState([]);
  const [addAlert, Feedback] = useAlert();

  //create date
  const today1 = new Date();
  const tomorow1 = new Date(today1.getTime() + 24 * 60 * 60 * 1000);
  const tomorowNoTime = new Date(new Date(tomorow1).setHours(0, 0, 0, 0));
  const tomorowEndofDay = new Date(
    new Date(tomorow1).setHours(23, 59, 59, 999)
  );

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isBig = useMediaQuery(theme.breakpoints.up("sm"));

  const [fromDate, setFromDate] = useState(tomorowNoTime);
  const [toDate, setToDate] = useState(tomorowEndofDay);

  useEffect(() => {
    fetchGraphql({
      query: `query Invoices($options: optionsInput) {
        invoices(options: $options) {
          invoiceId
          orderId
          invoiceDate
          deliveryDate
          customerName
          paymentStatus
          invoiceNote
          discountAmount
          discountType
          createdBy
          lastEditedBy
        }
      }`,
      variables: {
        options: { deliveryFromDate: fromDate, deliveryToDate: toDate },
      },
    }).then((result) => setData(result.data.invoices));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const [hidePopover, setHidePopover] = useState(false);

  const filterPopoverExit = () => {
    setHidePopover(false);
    // this.setActiveIcon();
  };

  const columns = [
    {
      name: "invoiceId",
      label: "Invoice Id",
    },
    {
      name: "invoiceDate",
      label: "Invoice Date",
      options: {
        display: isBig,
      },
    },
    {
      name: "customerName",
      label: "Customer Name",
      options: {
        display: isBig,
      },
    },
    {
      name: "deliveryDate",
      label: "Delivery Date",
      options: {
        filter: true,
        display: "true",
        filterType: "custom",
        filterOptions: {
          logic: (location, filters, row) => {
            return false;
          },
          display: (filterList, onChange, index, column) => {
            return (
              <Box>
                <Typography sx={{ marginBottom: "10px" }}>
                  Delivery Date
                </Typography>

                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="From Date"
                    sx={{ marginBottom: "10px" }}
                    openTo="day"
                    views={["year", "month", "day"]}
                    shouldDisableDate={(date) => {
                      const today = new Date();
                      const todayDate = new Date(date);

                      // if (date < today.setDate(today.getDate() - 1))
                      //   return true;

                      if (date > toDate) return true;

                      // if (todayDate.getDay() === 6) return true;
                    }}
                    value={fromDate || tomorow1}
                    onChange={(newValue) => {
                      setFromDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <Box sx={{ marginTop: "10px" }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="To Date"
                      openTo="day"
                      views={["year", "month", "day"]}
                      // shouldDisableDate={(date) => {
                      //   const today = new Date();
                      //   const todayDate = new Date(date);

                      //   if (date < today.setDate(today.getDate() - 1))
                      //     return true;

                      //   if (todayDate.getDay() === 6) return true;
                      // }}
                      value={toDate || tomorow1}
                      onChange={(newValue) => {
                        setToDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
            );
          },
        },
      },
    },
    {
      name: "createdBy",
      label: "Created By",
      options: {
        display: isBig,
      },
    },
    {
      name: "lastEditedBy",
      label: "Last Edited By",
    },
    {
      name: "customerName",
      label: "Customer name",
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          display: "flex",
          justifyContent: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              label={value}
              color={
                value === "Paid"
                  ? "success"
                  : value === "Unpaid"
                  ? "error"
                  : "secondary"
              }
            />
          );
        },
      },
    },
    {
      name: "balance",
      label: "Balance",
      options: {
        display: isBig,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Tooltip title="Send">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();

                    fetchGraphql({
                      query: `mutation SendInvoiceToCustomer($invoiceId: ID) {
                        sendInvoiceToCustomer(invoiceId: $invoiceId)
                      }`,
                      variables: { invoiceId: tableMeta.rowData[0] },
                    }).then((result) => {
                      if (result.data.sendInvoiceToCustomer) {
                        addAlert({
                          severity: "success",
                          message: "Message sent succesfuly",
                        });
                      } else {
                        addAlert({
                          severity: "error",
                          message: "Error: Message was not sent",
                        });
                      }
                    });
                  }}
                >
                  <SendIcon color={"primary"} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    },
  ];

  const handleFilterSubmit = (applyFilters) => {
    let filterList = applyFilters();

    // console.log(filterList);
    // this.setState({ isLoading: true });

    // // fake async request
    // this.xhrRequest(`/myApiServer?filters=${filterList}`, filterList).then(
    //   (res) => {
    //     this.setState({ isLoading: false, data: res.data });
    //   }
    // );
  };

  const options = {
    filterType: "multiselect",
    responsive: "scroll",
    onRowClick: (rowData) => {
      navigate(`invoice/${rowData[0]}`);
    },
    filter: true, // show the filter icon in the toolbar (true by default)
    serverSide: false,
    rowsPerPage: 100,
    rowsPerPageOptions: [5, 25, 50, 100],

    // makes it so filters have to be "confirmed" before being applied to the
    // table's internal filterList
    confirmFilters: true,
    selectableRows: "none",

    // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    //   <IconButton>
    //     <Tooltip title="Print Orders">
    //       <PrintIcon />
    //     </Tooltip>
    //   </IconButton>
    // ),

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => {
              fetchGraphql({
                query: `query Invoices($options: optionsInput) {
                  invoices(options: $options) {
                    invoiceId
                    orderId
                    invoiceDate
                    deliveryDate
                    customerName
                    paymentStatus
                    invoiceNote
                    discountAmount
                    discountType
                    createdBy
                    lastEditedBy
                  }
                }`,
                variables: {
                  options: {
                    deliveryFromDate: fromDate,
                    deliveryToDate: toDate,
                  },
                },
              }).then((result) => setData(result.data.invoices));

              handleFilterSubmit(applyNewFilters);
            }}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      // console.log("onFilterConfirm");
      console.dir(filterList);
    },

    onFilterDialogOpen: () => {
      // console.log("filter dialog opened");
    },
    onFilterDialogClose: () => {
      // console.log("filter dialog closed");
    },
    onFilterChange: (column, filterList, type) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        // console.log("updating filters via chip");
        handleFilterSubmit(newFilters);
      }
    },
    edit: "false",
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTable: {
          styleOverrides: {
            paper: {
              maxHeight: "calc(100% - 20px)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            },
            responsiveScroll: {
              maxHeight: "100% !important",
              height: "100% ",
            },
          },
        },
      },
    });

  return (
    <MiniDrawer sx={{ margin: "150px", height: "100vh" }} key="1">
      {() => (
        <>
          <DialogSave />
          <Feedback />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "calc(100% - 40px)",
              scrollSnapType: "y mandatory",
              // overflow: "hidden"
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Routes>
                <Route
                  path="/*"
                  element={
                    <Button
                      variant="outlined"
                      sx={{
                        margin: "0px auto 20px 0px  ",
                        scrollSnapAlign: "start",
                      }}
                      onClick={() => navigate("/invoices")}
                    >
                      <ArrowBackIcon />
                      Back
                    </Button>
                  }
                />
              </Routes>{" "}
              <Routes>
                <Route path="/invoice/:id" element={<EditInvoiceButton />} />
              </Routes>
            </Box>

            <Routes>
              <Route
                path="/"
                element={
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <IconMenu menuHeader={menuHeader} menu={menu} />
                    <Box sx={{ marginLeft: "20px", width: "100%" }}>
                      <ThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                          title={"Invoices"}
                          data={data}
                          columns={columns}
                          options={options}
                        />
                      </ThemeProvider>
                    </Box>
                  </Box>
                }
              />
              <Route
                path="/orders"
                element={
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <IconMenu menuHeader={menuHeader} menu={menu} />
                    <Box sx={{ marginLeft: "20px", width: "100%" }}>
                      <Orders />
                    </Box>
                  </Box>
                }
              />
              <Route
                path="/invoice/:id"
                element={
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <IconMenu menuHeader={menuHeader} menu={menu} />
                    <Box sx={{ marginLeft: "20px", width: "100%" }}>
                      <Invoice />
                    </Box>
                  </Box>
                }
              />
              <Route
                path="/edit-invoice/:id"
                element={
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <IconMenu menuHeader={menuHeader} menu={menu} />
                    <Box sx={{ marginLeft: "20px", width: "100%" }}>
                      <EditInvoice />
                    </Box>
                  </Box>
                }
              />
            </Routes>
          </Box>
        </>
      )}
    </MiniDrawer>
  );
}
